// 此API只使用数动云医

const API_URL = {

    //报告详情
    queryUserPhysicalRecordDetail: "userPhysicalRecord/queryUserPhysicalRecordDetail",
    //请求历史详情
    queryUserPhysicalBodyHistory: "/userPhysicalRecord/queryUserPhysicalBodyHistory"


}
export default API_URL


